module.exports = __webpack_public_path__ + "img/t4-15.e380493f.svg";